<template>
  <Popover v-bind="getBindValue">
    <template v-for="item in Object.keys($slots)" #[item]="data" :key="item">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
    <template v-if="!getBindValue.content && !$slots.content" #content>
      <DataList :options="options" :record="record" horizontal :truncate="false" />
    </template>
    <div class="mts-base-popover">
      <slot>
        {{ value ?? text }}
        <MIcon v-if="showIcon" icon="gengduo" color="#8991A1" />
      </slot>
    </div>
  </Popover>
</template>

<script setup lang="ts">
  import { Popover, PopoverProps } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { CellProps } from '@mts/components/Table';
  import { DataList, type DataListProps } from '@mts/components/Base';
  import { PCMode } from '@mts/utils/env';

  defineOptions({
    name: 'BasePopover',
    inheritAttrs: false,
  });

  interface BasePopoverProps extends PopoverProps, Partial<CellProps> {
    value?: unknown;
    showIcon?: boolean;
    options?: DataListProps['options'];
  }
  const props = withDefaults(defineProps<BasePopoverProps>(), {
    trigger: PCMode ? 'hover' : 'click',
    destroyTooltipOnHide: false,
    autoAdjustOverflow: true,
    placement: 'top',
    visible: void 0,
    open: void 0,
    showIcon: true,
    options: () => [],
  });

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    const { text, record, column, index, value, showIcon, options, ...restProps } = props;

    return { ...attrs, ...restProps } as PopoverProps;
  });
</script>

<style lang="less">
  .ant-popover {
    min-width: 160px;

    .ant-popover-content > .ant-popover-inner {
      padding: 14px 16px;
      border-radius: @border-radius;
    }

    .mts-base-list {
      min-width: 240px;
      max-width: 480px;
    }

    &.mts-popover-tooltip {
      .ant-popover-arrow::before,
      .ant-popover-content > .ant-popover-inner {
        background-color: rgb(0 0 0 / 85%);
      }

      .ant-popover-content > .ant-popover-inner {
        max-width: 60vw;
        max-height: 320px;
        padding: 6px 8px;
        overflow: auto;
      }

      .ant-popover-inner-content {
        color: #fff;
      }
    }
  }
</style>
